import { render, staticRenderFns } from "./TranslationOrderPrint.vue?vue&type=template&id=c0b7b80c&scoped=true&"
import script from "./TranslationOrderPrint.vue?vue&type=script&lang=js&"
export * from "./TranslationOrderPrint.vue?vue&type=script&lang=js&"
import style0 from "./TranslationOrderPrint.vue?vue&type=style&index=0&id=c0b7b80c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b7b80c",
  null
  
)

export default component.exports